import React from 'react'
import {useTheme, makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Pagination from './pagination'
import {AssignedContentIcon} from 'resources/icons'

const verticalCentering = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    color: '#4f576e',
    fontSize: '12pt',
  },
  count: {
    display: 'flex',
  },
  countIcon: {
    ...verticalCentering,
    marginTop: -5,
    marginRight: 5
  },
  questionsLabel: {...verticalCentering},
  countLabel: {...verticalCentering},
  pagination: {
    flexGrow: 1
  }
}))

export default function Footer ({context}) {

  const {tab} = context
  const classes = useStyles()
  const page = parseInt(context.query.page)
  const {recordCount, pageSize} = context.quizPaging
  const pageCount = Math.ceil(recordCount / pageSize)

  return (
    <Box className={classes.root}>
      <Box className={classes.count}>
        {tab != 'question-bank' && <Box className={classes.countIcon}><AssignedContentIcon fill={'#68728b'} /></Box>}
        {tab == 'question-bank' && <Box className={classes.questionsLabel}>{context.translate('question-bank-pagination-label')}</Box>}
        <Box className={classes.countLabel}>: {recordCount}</Box>
      </Box>
      {tab != 'assessments' && pageCount > 1 && (
        <Box className={classes.pagination}>
          <Pagination context={context} page={isNaN(page) ? 1 : page} count={pageCount} />
        </Box>
      )}
    </Box>
  )
}

